module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "spw-tabs.1964cfa0.svg";